import { useState } from "react";
import { dateBeautify } from "../helpers/utils";
import assig1 from "../assets/images/assig-1.png";
import inProgress from "../assets/images/in-progress.svg";
import projectIcon from "../assets/images/fiber_manual_record.svg";
import DataLoading from "./DataLoading";
import assig5 from "../assets/images/assig-5.png";
import { TaskOrderTotalType } from "../pages/Priority/api";
import inReview from "../assets/images/in-review.svg";
import hold from "../assets/images/hold.svg";
import done from "../assets/images/green_status_circle.svg";
import open from "../assets/images/gray_status_circle.svg";
import backlog from "../assets/images/gray_status_circle.svg";
import devCompleted from "../assets/images/purple_status_circle.svg";
import qAProduction from "../assets/images/purple_status_circle.svg";
import stagging from "../assets/images/purple_status_circle.svg";
import qAStagging from "../assets/images/purple_status_circle.svg";
import DefaultImage from "../profile_images/DefaultImage";

type Status =
  | "Backlog"
  | "Open"
  | "InProgress"
  | "DevCompleted"
  | "InReview"
  | "Stagging"
  | "QAStagging"
  | "QAProduction"
  | "Done"
  | "Hold";

type Priority = "High" | "Medium" | "Low";

type AssigneeType = {
  _id: string;
  profilepic: string;
  name: string;
};

type Ticket = {
  _id: string;
  name: string;
  due_date: string;
  status: { _id: string; name: Status };
  assignee: AssigneeType;
  estimation_time: string;
  log_time: number;
};

type SubTask = Ticket;

export type TaskType = Ticket & {
  taskId: string;
  description: string;
  priority: Priority;
  start_date: string;
  members: AssigneeType[];
  subTasks: SubTask[];
  projectId: { _id: string; project_name: string };
  reference_taskId: string;
  documents: [];
  statusId: string;
  createdAt?: string;
  createdBy?: string;
};

const SubTaskList = ({
  subTasks,
  selectSubTask,
  selectedSubTaskId,
}: {
  subTasks: SubTask[];
  selectSubTask: any;
  selectedSubTaskId: string;
}) => {
  const handleClick = (_id: string) => (e: any) => {
    e.stopPropagation();
    selectSubTask(_id);
  };
  return (
    <div className="sub-tasks">
      <div className="line-exp">
        {subTasks?.map(({ _id, name, status, due_date, assignee }) => {
          // console.log('selectedSubTaskId === _id ::', selectedSubTaskId === _id, selectedSubTaskId, _id)
          return (
            <div key={_id} className="d-flex">
              <p className="d-flex pjt-wid"> </p>
              <div
                onClick={handleClick(_id)}
                className={`d-flex mt-five sub-tsk-ml lst-tsk-nm ${
                  selectedSubTaskId === _id ? "clicked" : ""
                }`}
              >
                <div className="d-flex sub-tsk-wid tsk-box">
                  <div className="d-flex list-nm-ryt">
                    <div className="d-flex sub-tsk-icon">
                      <span className="material-icons-round in-review">
                        subdirectory_arrow_right
                      </span>
                    </div>
                    <div className="d-flex tsk-id">
                      <p>{_id}</p>
                    </div>
                    <div className="d-flex tsk-nm">
                      <p>{name}</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex sub-assig-wid assig-wid assig-box">
                  {assignee?.profilepic ? (
                    <div className="d-flex assig-pic">
                      {/* <img src={assignee?.profilepic} alt="" /> */}
                      <DefaultImage
                        src={assignee?.profilepic}
                        alt=""
                        className=""
                        letter={assignee?.name[0]}
                      />
                    </div>
                  ) : (
                    <div title={assignee?.name} className="d-flex assig-pic">
                      <DefaultImage
                        src={assignee?.profilepic}
                        alt=""
                        className=""
                        letter={assignee?.name[0]}
                      />{" "}
                    </div>
                  )}
                </div>
                <div className="d-flex sub-sts-wid sts-wid box">
                  <img src={taskStatusIcons[status?.name]} alt="" />
                  <p className="status-nm">{status?.name}</p>
                </div>
                <div className="d-flex sub-dd-wid dd-wid box">
                  <p className="dd">{dateBeautify(due_date)}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const TaskAssignees = ({ assignees }: { assignees: AssigneeType[] }) => {
  return (
    <div className="d-flex assig-wid assig-box">
      {assignees?.map((assignee: any) => (
        <div key={assignee._id} className="d-flex assig-pic">
          {assignee?.profilepic ? (
            // <img src={assignee?.profilepic} title={assignee?.name} alt="" />
            <DefaultImage
              src={assignee?.profilepic}
              alt=""
              className=""
              letter={assignee?.name[0]}
            />
          ) : (
            <div title={assignee?.name} className="d-flex assig-pic">
              <DefaultImage
                src={assignee?.profilepic}
                alt=""
                className=""
                letter={assignee?.name[0]}
              />{" "}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const TaskItem = ({
  task,
  selectTask,
  selectedTaskId,
}: {
  task: any;
  selectTask: any;
  selectedTaskId: string;
}) => {
  const { taskId, name, members, status, due_date, projectId, subTasks, _id } =
    task;

  const handleClick = () => {
    selectTask(_id);
  };

  return (
    <div className={`lst-tsk-main`} onClick={handleClick}>
      <div
        className={`d-flex lst-tsk-nm ${
          _id === selectedTaskId ? "clicked" : ""
        }`}
      >
        <div className="d-flex pjt-wid">
          <div className="d-flex flex-align-center icon-title-sm">
            <img src={projectIcon} alt="" className="img-fluid" />
            <span> {projectId?.project_name} </span>
          </div>
        </div>
        <div className="d-flex tsk-wid tsk-box">
          <div className="d-flex list-nm-ryt">
            <div className="d-flex tsk-icon">
              <span className="material-icons-round">bolt</span>
            </div>
            <div className="d-flex tsk-id">
              <p>{taskId}</p>
            </div>
            <div className="d-flex tsk-nm">
              <p>{name}</p>
            </div>
          </div>
          {/* <div className="d-flex tsk-exp-more">
                        <span className="material-icons-round">expand_less</span>
                    </div> */}
        </div>
        <TaskAssignees assignees={members} />
        <div className="d-flex sts-wid box">
          <img src={taskStatusIcons[status?.name]} alt="" />
          <p className="status-nm">{status?.name}</p>
        </div>
        <div className="d-flex dd-wid box">
          <p className="dd">{dateBeautify(due_date)}</p>
        </div>
        {/* <div className="d-flex prio-wid prio-box high">
                    <span className="material-icons-round">keyboard_double_arrow_up</span>
                    <p className="prio-nm">{priority}</p>
                </div> */}
      </div>
      <SubTaskList
        subTasks={subTasks}
        selectSubTask={selectTask}
        selectedSubTaskId={selectedTaskId}
      />
    </div>
  );
};

export const TaskPriorityList = ({
  taskOrderList,
  isTasksListLoading,
  selectEmployee,
  priorityOrderTotal,
}: {
  selectEmployee: string | undefined;
  priorityOrderTotal: TaskOrderTotalType | undefined;
  taskOrderList: TaskType[] | undefined;
  isTasksListLoading: any;
}) => {
  const [selectedTask, setSelectedTask] = useState("");

  if (isTasksListLoading && selectEmployee) {
    return <DataLoading />;
  }

  return (
    <>
      <div className="tsk-lists-wrap">
        {taskOrderList && taskOrderList.length > 0 ? (
          <div className="tsk-lists pjt tsk aasig sts dd">
            <div className="dtls-mn-sec">
              <div className="d-flex list-headings">
                <p className="d-flex pjt-wid">project</p>
                <p className="d-flex tsk-wid">task</p>
                <p className="d-flex assig-wid">assignees</p>
                <p className="d-flex sts-wid">status</p>
                <p className="d-flex dd-wid">due date</p>
              </div>
              {taskOrderList?.map((task: TaskType) => (
                <TaskItem
                  key={task._id}
                  task={task}
                  selectTask={setSelectedTask}
                  selectedTaskId={selectedTask}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="tsk-lists empty-screen-wrap">
            <div className="card-ui">
              <div className="icon-block-wrap">
                {" "}
                <span className="tsk-icon material-icons-round">
                  ramen_dining
                </span>{" "}
              </div>
              <h3>Look like there’s currently nothing to see here</h3>
              <p> No results were found. Request to select assignee. </p>
            </div>
          </div>
        )}
      </div>
      {selectEmployee ? (
        <div className="dtls-bottom-sec">
          <div className="mn-dtls-vw container">
            <div className="dtls-bottom-sec-last-update-action d-flex">
              <div className="user-img-details-last-updated d-flex">
                <div className="user-image-block-sm">
                  <img src={assig5} alt="assig-5" className="img-fluid" />
                </div>
                <div className="user-name-last-update">
                  {priorityOrderTotal?.updatedBy?.name}{" "}
                  <span> Last updated • {priorityOrderTotal?.updatedOn} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
const taskStatusIcons: any = {
  InProgress: inProgress,
  InReview: inReview,
  Hold: hold,
  Done: done,
  Open: open,
  Backlog: backlog,
  DevCompleted: devCompleted,
  QAProduction: qAProduction,
  Stagging: stagging,
  QAStagging: qAStagging,
};

export const TaskList = ({
  taskList,
  isPriorityLoading,
  isPriorityError,
}: {
  taskList: TaskType[] | undefined;
  isPriorityLoading: any;
  isPriorityError: any;
}) => {
  const [selectedTask, setSelectedTask] = useState("");

  if (isPriorityLoading || isPriorityError) {
    return <DataLoading />;
  }

  return (
    <div className="tsk-lists-wrap">
      <div className="tsk-lists pjt tsk assig sts dd">
        <div className="dtls-mn-sec">
          {taskList && taskList.length > 0 ? (
            <>
              {" "}
              <div className="d-flex list-headings">
                <p className="d-flex pjt-wid">project</p>
                <p className="d-flex tsk-wid">task</p>
                <p className="d-flex assig-wid">assignees</p>
                <p className="d-flex sts-wid">status</p>
                <p className="d-flex dd-wid">due date</p>
              </div>
              {taskList?.map((task: TaskType) => (
                <TaskItem
                  key={task?._id}
                  task={task}
                  selectTask={setSelectedTask}
                  selectedTaskId={selectedTask}
                />
              ))}
            </>
          ) : (
            <div className="tsk-lists empty-screen-wrap">
              <div className="card-ui">
                <div className="icon-block-wrap">
                  {" "}
                  <span className="tsk-icon material-icons-round">
                    ramen_dining
                  </span>{" "}
                </div>
                <h3>Look like there’s currently nothing to see here</h3>
                <p> No results were found. Request to add task. </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
